import { render, staticRenderFns } from "./DashboardEnlace.vue?vue&type=template&id=2ece488e&scoped=true"
import script from "./DashboardEnlace.vue?vue&type=script&lang=js"
export * from "./DashboardEnlace.vue?vue&type=script&lang=js"
import style0 from "./DashboardEnlace.vue?vue&type=style&index=0&id=2ece488e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ece488e",
  null
  
)

export default component.exports